var map = {
	"./1.jpg": 5897,
	"./2.jpg": 2306,
	"./3.jpg": 8256,
	"./4.jpg": 6009,
	"./5.jpg": 9841,
	"./6.jpg": 9282,
	"./7.jpg": 9478,
	"./8.jpg": 2333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;